<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-25 17:52:05
 * @LastEditors: guanbowen 
 * @LastEditTime: 2023-03-07 15:01:28
-->
<template>
  <div class="x-table-container">
    <div class="x-table-body">
      <!-- 你不用这个(为啥要设这个呢，因为要统一表格里面无数据的展示) -->
      <el-table
        v-if="!$slots.table && tableHeight > 0"
        ref="table"
        :show-header="true"
        v-loading="loading"
        :data="dataSource"
        :height="tableHeight"
        :highlight-current-row="true"
        border
        @selection-change="onSelectionChange"
        @sort-change="onSortChange"
        @row-click="onRowClick"
      >
        <slot></slot>
        <template #empty>
          <div class="flex-column table-nodata">
            <!-- <img src="" alt="" /> -->
            <span>暂无数据</span>
          </div>
        </template>
      </el-table>
      <!-- 就用这个插入表格 -->
      <slot name="table" />
    </div>
    <x-pagination
      v-if="isPagination"
      :limit.sync="paginationData.pageSize"
      :page-sizes="pageSizes"
      :page.sync="paginationData.pageNum"
      :total="paginationData.total"
      @pagination="onPageChange"
    >
    </x-pagination>
  </div>
</template>

<script>
  export default {
    name: 'XTable',
    props: {
      dataSource: {
        type: Array,
        required: false,
        default: () => []
      },
      loading: {
        type: Boolean,
        required: false,
        default: false
      },
      pagination: {
        type: Object,
        required: false,
        default: () => ({
          pageSize: 10,
          pageNum: 1
        })
      },
      // 每页数量
      pageSizes: {
        type: Array,
        default() {
          return [10, 20, 30, 50]
        }
      },
      isPagination: {
        type: Boolean,
        default: true
      },
      height: {
        type: Number,
        default: null
      }
    },
    data() {
      return {
        paginationData: {},
        tableHeight: 0,
        tableWidth: 0
      }
    },
    watch: {
      pagination: {
        handler(newValue) {
          this.paginationData = { ...newValue, total: newValue.total * 1 }
        },
        deep: true,
        immediate: true
      },
      dataSource: {
        handler() {
          this.$nextTick(() => {
            this.$refs.table.doLayout()
          })
        },
        deep: true
      },
      tableHeight: {
        handler() {
          this.$nextTick(() => {
            this.$refs.table.doLayout()
          })
        },
        deep: true
      },
      tableWidth: {
        handler() {
          this.$nextTick(() => {
            this.$refs.table.doLayout()
          })
        },
        deep: true
      }
    },
    activated() {
      // myTable是表格的ref属性值
      if (this.$refs.table && this.$refs.table.doLayout) {
        this.$refs.table.doLayout()
      }
    },
    mounted() {
      this.tableHeight = this.height
        ? this.height
        : document.querySelector('.x-table-body')?.attributes[0].ownerElement.clientHeight
      this.tableWidth = document.querySelector('.x-table-body')?.attributes[0].ownerElement.clientWidth
    },
    methods: {
      onSelectionChange(selection) {
        this.$emit('on-selection-change', selection)
      },
      onSortChange(value) {
        this.$emit('on-change', this.paginationData, value)
      },
      onRowClick(value) {
        this.$emit('on-row-click', value)
      },
      /**
       * 分页改变事件触发
       * @param value
       */
      onPageChange(value) {
        this.$emit('on-change', value, 'isPageChange')
      },
      /**
       * pageSize改变触发
       * @param size
       */
      handleSizeChange(size) {
        this.$emit('pageSizeChange', size)
      },
      doLayout() {
        this.$nextTick(() => {
          this.$refs.table.doLayout()
        })
      }
    }
  }
</script>

<style lang="scss">
  .x-table-container {
    font-size: 12px;
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;
    height: 0;
    min-height: 200px;

    .x-table-body {
      position: relative;
      overflow: hidden;
      flex: 1;
      width: 100%;
      height: 0;

      .el-table--medium .el-table__cell {
        // padding: 6px 0;
      }

      .el-table th.el-table__cell {
        font-weight: 600;
        color: #687182;
        // padding: 4px 0;
        background: #ededed;
      }

      .el-table__row {
        &.hover-row {
          // background-color: rgb(237 238 240 / 50%) !important;
        }
      }

      .action-column {
        &.color-delete {
          color: #f56c6c;
        }
      }
    }

    .table-nodata {
      align-items: center;
      justify-content: center;
    }
  }
</style>
